import Vue from 'vue'
import qs from 'qs'
import config from '@/config/index'

const path = 'cashBills'

const initialState = () => {
  return {
    path: 'cashBills',
    list: {
      searches: {
        q: null,
        startDate: null,
        endDate: null,
        status: null
      },
      descending: true,
      sortBy: 'bookDate',
      page: 1,
      rowsPerPage: 10,
      totalItems: 0
    },
    headers: [
      { text: '#', sortable: false, align: 'center' },
      { text: 'Code', value: 'code', sortable: true, align: 'left' },
      { text: 'Name', value: 'name', sortable: true, align: 'left' },
      { text: 'Customer', value: 'customer.name', sortable: true, align: 'left' },
      { text: 'Date', value: 'bookDate', sortable: true, align: 'center' },
      { text: 'Price', value: 'totalPriceAmount', sortable: false, align: 'right' },
      { text: 'Vat', value: 'totalVatAmount', sortable: false, align: 'right' },
      { text: 'Total', value: 'totalAmount', sortable: false, align: 'right' },
      { text: 'Status', value: 'status', sortable: true, align: 'center' },
      { text: '', value: '', sortable: false, align: 'center' }
    ]
  }
}

const mutations = {
  resetState (state) {
    state = initialState()
  },
  SET_LIST (state, list) {
    state.list = list
  }
}

const getters = {
  printoutUrl: (state, getters, rootState, rootGetters) => (id) => {
    return `${config.serverURI}/${path}/printout/${id}?format=PDF&access_token=${rootGetters.token}`
  }
}

const actions = {
  reset ({ commit }) {
    commit('resetState')
  },
  fetchItem ({ state }, payload) {
    return Vue.axios.get(`${config.serverURI}/${path}/${payload}`)
  },
  create ({ state }, payload) {
    return Vue.axios.post(`${config.serverURI}/${path}`, payload)
  },
  update ({ state }, payload) {
    return Vue.axios.put(`${config.serverURI}/${path}/${payload.id}`, payload)
  },
  complete ({ state }, payload) {
    return Vue.axios.patch(`${config.serverURI}/${path}/complete/${payload.id}`, payload)
  },
  cancel ({ commit, dispatch }, payload) {
    return Vue.axios.patch(`${config.serverURI}/${path}/cancel/${payload.id}`, payload)
  },
  delete ({ state }, payload) {
    return Vue.axios.delete(`${config.serverURI}/${path}/${payload.id}`)
  },
  loadItems ({ state }) {
    return Vue.axios.get(`${config.serverURI}/${path}/page?${qs.stringify(state.list, { allowDots: true })}`)
  }
}

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/cashBill.js